import { Box, Typography } from '@mui/material'
import ticketImage from 'assets/images/ticketImg.png'

export type TicketDataRow = {
  tittle: string
  value: string
}

type props = {
  tittle?: string
  showImage?: boolean
  sx?: any
  rows: TicketDataRow[]
}

const TicketData: React.FC<props> = ({
  tittle,
  showImage = false,
  sx,
  rows,
}) => {
  return (
    <>
      <Box sx={{ ...sx }}>
        {!!tittle && (
          <div className="flex justify-center mb-4">
            <Typography variant="h5">{'Ticket Details'}</Typography>
          </div>
        )}
        <div className="flex space-x-4">
          {showImage && (
            <img src={ticketImage} className="h-[200px] rounded-lg" />
          )}
          <div>
            {rows.map((row) => (
              <div key={row.tittle} className="flex mt-1">
                <Typography
                  variant="subtitle2"
                  sx={{ width: 120, fontSize: '14px' }}
                >
                  {row.tittle}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ width: 200, fontSize: '12px', wordWrap: 'break-word' }}
                >
                  {row.value}
                </Typography>
              </div>
            ))}
          </div>
        </div>
      </Box>
    </>
  )
}

export default TicketData
